// ═══════════════════════════════════════════════════════════════════════════════
// Membership pricing catalog + public API query
// ═══════════════════════════════════════════════════════════════════════════════
import { z } from 'zod';
import { MEMBERSHIP_PRICING_ITEM_KEYS, MEMBERSHIP_PRICING_LOCALES, } from '../types/membershipPricing.js';
const localeTextSchema = z.object({
    en: z.string().max(200),
    'zh-Hant': z.string().max(200),
    'zh-Hans': z.string().max(200),
});
const remarkTextSchema = z.object({
    en: z.string().max(500),
    'zh-Hant': z.string().max(500),
    'zh-Hans': z.string().max(500),
});
export const membershipPricingCatalogItemSchema = z.object({
    key: z.enum(MEMBERSHIP_PRICING_ITEM_KEYS),
    enabled: z.boolean(),
    sortOrder: z.number().int().min(0).max(1000),
    label: localeTextSchema,
    remark: remarkTextSchema,
});
export const membershipPricingCatalogSettingSchema = z.object({
    items: z.array(membershipPricingCatalogItemSchema).min(1).max(MEMBERSHIP_PRICING_ITEM_KEYS.length),
});
export const publicMembershipPricingQuerySchema = z.object({
    locale: z.enum(MEMBERSHIP_PRICING_LOCALES).default('en'),
});
//# sourceMappingURL=membershipPricing.schema.js.map